import { render } from "./Lottery.vue?vue&type=template&id=ef38870e&ts=true"
import script from "./Lottery.vue?vue&type=script&lang=ts"
export * from "./Lottery.vue?vue&type=script&lang=ts"

import "./Lottery.vue?vue&type=style&index=0&id=ef38870e&lang=scss"

import exportComponent from "D:\\work\\fengmian\\Activity\\2023qixi\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__